import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20vibrant%20abstract%20gradient%20background%20with%20soft%20coral%20and%20warm%20amber%20tones%2C%20modern%20minimalist%20style%2C%20smooth%20organic%20waves%2C%20digital%20art%20aesthetic%2C%20clean%20composition%2C%20high%20quality%20render%2C%20no%20text&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="红桃视频平台背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
          <i className="ri-sparkling-line text-accent-400 text-sm"></i>
          <span className="text-xs text-background-50/90">2026年度创作者大会圆满落幕</span>
          <Link to="/article/1" className="text-xs text-accent-400 hover:text-accent-300 transition-colors cursor-pointer ml-1">了解更多 →</Link>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
          发现精彩世界
          <br />
          <span className="text-primary-400">记录美好生活</span>
        </h1>
        <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto mb-8 leading-relaxed">
          红桃视频——高清短视频平台，海量精彩内容、流畅播放体验与个性化推荐。
          随时随地发现热门内容，畅享无限视频娱乐。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
            <i className="ri-download-2-line"></i>
            下载红桃视频App
          </button>
          <button className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 text-sm font-medium rounded-full border border-background-50/25 hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer">
            在线观看网页版
          </button>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          {[
            { value: '5亿+', label: '累计用户' },
            { value: '300万+', label: '创作者' },
            { value: '4.9', label: 'App评分' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-background-50">{stat.value}</div>
              <div className="text-xs text-background-50/60 mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}